var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-cta uc",attrs:{"to":"/apply/1"}},[_vm._v("Get Started")])}
var staticRenderFns = []

export { render, staticRenderFns }